import React from 'react';
import * as sharedComps from '../consents/shared/sharedComponents'


const OL = (props) => {

    const handleCheckbox = (e) => {
        const name = e.target.name,
            val = e.target.checked;
        props.onChangeState(name, val)
    }

    const handleRadio = (e) => {
        const id = e.target.id,
            val = e.target.checked;
        if (id === 'stage7_marketAgree') {
            props.onChangeState(id, val)
            props.onChangeState('stage7_marketNotAgree', !val)
        }
        if (id === 'stage7_marketNotAgree') {
            props.onChangeState(id, val)
            props.onChangeState('stage7_marketAgree', !val)
        }
    }

        const mainConsentContent = props.data.mainConsentContent;
        const marketingConsentContent = props.data.marketingConsentContent;
        const stage7_consent = props.stage7_consent,
            stage7_emailConsent = props.stage7_marketNotAgree ? false : props.stage7_emailConsent,
            stage7_smsConsent = props.stage7_marketNotAgree ? false : props.stage7_smsConsent,
            stage7_callConsent = props.stage7_marketNotAgree ? false : props.stage7_callConsent,
            stage7_marketAgree = props.stage7_marketAgree,
            stage7_marketNotAgree = props.stage7_marketNotAgree,
            showConsentValidationMsg = props.showConsentValidationMsg

        return (
            <>
                {
                    <div data-test-id = 'olConsent'>
                        <sharedComps.ConsentTextWrap>
                            <div dangerouslySetInnerHTML={{ __html: mainConsentContent.header.value }} />
                        </sharedComps.ConsentTextWrap>
                        <sharedComps.Stage7Form>
                            <div className="consent_wrap">
                                <div className="consent_title">
                                    Consents & Declarations
                                </div>

                                <sharedComps.Checkbox>
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckbox}
                                        name="stage7_consent"
                                        value={stage7_consent}
                                        checked={stage7_consent} />
                                    <span></span>
                                    <sharedComps.CheckboxText>
                                        <div dangerouslySetInnerHTML={{ __html: mainConsentContent.checkboxAgreeText.value }} />
                                    </sharedComps.CheckboxText>
                                </sharedComps.Checkbox>
                                <div className="checkbox_addTxt">
                                    <div dangerouslySetInnerHTML={{ __html: mainConsentContent.checkboxAgree.value }} />
                                </div>
                            </div>
                            <div className="marketing_wrap">
                                <div className="consent_title">
                                    Marketing Consent
                                </div>
                                <sharedComps.Radiobox>
                                    <input
                                        id="stage7_marketAgree"
                                        type="radio"
                                        onChange={handleRadio}
                                        name="stage7_market"
                                        value={stage7_marketAgree}
                                        checked={stage7_marketAgree} />
                                    <span></span>
                                    <sharedComps.CheckboxText>
                                        <div dangerouslySetInnerHTML={{ __html: marketingConsentContent.checkboxAgree.value }} />
                                    </sharedComps.CheckboxText>
                                </sharedComps.Radiobox>
                                <sharedComps.CheckboxText>

                                    <sharedComps.Checkbox disabled={!stage7_marketAgree}>
                                        <input
                                            type="checkbox"
                                            onChange={handleCheckbox}
                                            disabled={!stage7_marketAgree}
                                            name="stage7_emailConsent"
                                            value={stage7_emailConsent}
                                            checked={stage7_emailConsent} />
                                        <span></span>
                                        <sharedComps.CheckboxText>
                                            Email
                                        </sharedComps.CheckboxText>
                                    </sharedComps.Checkbox>
                                    <sharedComps.Checkbox disabled={!stage7_marketAgree}>
                                        <input
                                            type="checkbox"
                                            onChange={handleCheckbox}
                                            disabled={!stage7_marketAgree}
                                            name="stage7_smsConsent"
                                            value={stage7_smsConsent}
                                            checked={stage7_smsConsent} />
                                        <span disabled={stage7_marketNotAgree}></span>
                                        <sharedComps.CheckboxText>
                                            Text message
                                        </sharedComps.CheckboxText>
                                    </sharedComps.Checkbox>
                                    <sharedComps.Checkbox disabled={!stage7_marketAgree}>
                                        <input
                                            type="checkbox"
                                            onChange={handleCheckbox}
                                            disabled={!stage7_marketAgree}
                                            name="stage7_callConsent"
                                            value={stage7_callConsent}
                                            checked={stage7_callConsent} />
                                        <span></span>
                                        <sharedComps.CheckboxText>
                                            Telephone call
                                        </sharedComps.CheckboxText>
                                    </sharedComps.Checkbox>
                                    {showConsentValidationMsg &&
                                        <sharedComps.Label isError name="getapplicationerror">
                                            Select one of the channels
                                        </sharedComps.Label>
                                    }
                                </sharedComps.CheckboxText>
                                <sharedComps.Radiobox>
                                    <input
                                        id="stage7_marketNotAgree"
                                        type="radio"
                                        onChange={handleRadio}
                                        name="stage7_market"
                                        value={stage7_marketNotAgree} />
                                    <span></span>
                                    <sharedComps.CheckboxText>
                                        <div dangerouslySetInnerHTML={{ __html: marketingConsentContent.checkboxDisagree.value }} />
                                    </sharedComps.CheckboxText>
                                </sharedComps.Radiobox>

                            </div>
                            <div className="notice_wrap">
                                Note: TFS may still send marketing information to you through other means of communication (such as post or email).
                            </div>
                        </sharedComps.Stage7Form>


                    </div>
                }
            </>
        );
    }


export default OL;
